// extracted by mini-css-extract-plugin
module.exports = {"ad-Wrapper":"ad-slot-row-m__ad-Wrapper__199QL"};